<template>
    <div>
        TEST COMPONENT
        <v-container>
            <v-row>
                <v-col cols="4"> <component-datetime-picker v-model="result" label="Mulai" :rules="[rules.required]" /> </v-col>
            </v-row>

            <v-row>
                <v-col>
                    {{result}}
                    <v-text-field type="text" v-mask="'####.####.####.####'" v-model="maskValue" placeholder="0000.0000.0000.0000" outlined />
                    <v-btn @click="testKbli()">TEST</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3">
                    <v-text-field label="Money" v-model="money" prefix="Rp" @blur="moneyFocus = false" @focus="moneyFocus = true" />
                </v-col>
                <v-col>
                    <v-btn @click="showMoney()">Amount</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3"> <v-text-field label="Nilai Penawaran" v-model="nilaiPenawaranFormatted" prefix="Rp" /> </v-col>
                <v-btn @click="showMoney()">Nilai Penawaran</v-btn>
            </v-row>
            <v-row>
                <v-col cols="3"> <text-field-rupiah label="Nilai Rupiah" v-model="nilaiPenawaran" outlined readonly/> </v-col>
            </v-row>

        </v-container>
    </div>
</template>


<script>

import DateTimePicker from "./../components/DateTimePicker.vue";
import TextFieldRupiah from "./../components/TextFieldRupiah.vue";
import { rules as Rules } from "./../lib/rules";
import axios from 'axios';

const apiUrl = process.env.VUE_APP_ROOT_API;


function formatAsCurrency (value) {
  return '' + value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
}

const isDecimal = function(value) {
  return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value)
}

const mask = function(value, dp = -1, editing = false, ds = ',', gs = '.') {
  if (editing || !isDecimal(value)) {
    return value.replace('.', ds)
  }

  const parts = value.split(/\./)

  let dec = parts[1] || ''

  if (dp >= 0) {
    dec = dec.length < dp ? dec.padEnd(dp, '0') : dec.substr(0, dp)
  }

  if (dec) {
    dec = ds + dec
  }

  return parts[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + gs) + dec
}

const unmask = function(value, ds = ',') {
  return value.replace(ds, '.')
}


export default {
    components: {
        "component-datetime-picker": DateTimePicker,
        "text-field-rupiah": TextFieldRupiah
    },

    data() {
        return {
            result: "2020-12-13 04:33:00",
            rules: Rules,
            maskValue: "",
            moneyText: '950000000000',
            moneyFocus: false,

            nilaiPenawaran: 350750000
        }
    },

    computed: {
        money: {
            get() {
                return mask(this.moneyText, 0, this.moneyFocus);
            },
            set(value) {
                this.moneyText = unmask(value);
            }
        },

        nilaiPenawaranFormatted: {
            get() {
                return formatAsCurrency(this.nilaiPenawaran);
            },
            set(value) {
                this.nilaiPenawaran = Number(value.replace(/[^0-9,]/g, ''));
            }
        }
    },

    methods: {
        testKbli() {
            const listKbli = "22";
            axios.get(`${apiUrl}/vendor/kbli/${listKbli}`)
                .then( (response) => {
                console.log(response.data);
            });

           console.log("MaskValue: ", this.maskValue);
        },


        showMoney() {
            console.log(Number(this.nilaiPenawaran) + 100000);
        },
    }
}

</script>